const vars = {
    firebaseApiUrl: 'https://europe-west1-couleur-cuisine-3f61f.cloudfunctions.net',
    hostname: 'https://couleur-cuisine-3f61f.web.app'
};

export default vars;